var exports = {
  "R": "heading__Ij4V9z",
  "h": "description__FuQlPQ",
};

module.exports = exports;
